import { product2ShoppingProduct } from 'redux-store/products/products.utils';
import type { IAppSettings } from 'redux-store/settings/settings.store';

import type { IProduct } from '@inter-ikea-kompis/types/lib';
import { TotalPriceCalculator } from '@inter-ikea-kompis/utilities/lib';

export const getTotalAmountForProducts = (products: IProduct[], settings: IAppSettings): number => {
  const totalPricesDualCurrency = TotalPriceCalculator.calculateMultiple(products.map(product2ShoppingProduct), settings.localisation.dateFormat);

  return totalPricesDualCurrency[0].inclTax;
};
